import { Box, Button, IconButton } from "@mui/material";
import ArrowRightAltTwoToneIcon from "@mui/icons-material/ArrowRightAltTwoTone";
import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ConfigBottomBar, { otherConfigOptionsAttributes, otherConfigOptionsAttributesFeature } from "../configSetupScreen/widget/configBottomBar";
import "./catelogueConfig/catalogue.css";
import { ConfigOptionsContext } from "../../../../components/newPortal/NewPortalLayout";
import PhoneFrameComponent from "../../../onboarding/PhoneFrame";
import CheckoutFeatureConfig from "./orderSummary/OrderSummaryConfig";
import Loader from "../../../../components/loading/Loader";
import FeatureSelectionComponent from "./widget/FeaturesSelectionComponent";
import GenericComponentConfig from "../GenericComponentConfig/GenericComponentConfig";
import { ServiceFactory } from "../../../../components/newPortal/Service/Factory/ServiceFactory";

interface OptionalFeatureLayoutProps {
  children?: React.ReactNode;
  disableBack: boolean;
  handleStepIconClick?: (stepNumber: number) => void;
  setCompleted?: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  currentStep?: number;
  newPortal?:boolean
}

const OptionalFeatureLayout: React.FC<OptionalFeatureLayoutProps> = ({
  disableBack,handleStepIconClick,setCompleted,currentStep,newPortal
}) => {
  const context = useContext(ConfigOptionsContext);
  const [dataFieldValidity, setDataFieldValidity] = useState<Record<string, boolean>>({})
  const [previewTrigger,setPreviewTrigger]=useState<Record<string,number>>({})
  const [featureList,setFeatureList]=useState<otherConfigOptionsAttributesFeature[]>([])
  const [subFeature,setSubFeature]=useState<otherConfigOptionsAttributesFeature>()
     
  useEffect(()=>{
    localStorage.setItem("activeChild", "[]")
    // if(disableBack){
    //   localStorage.setItem("activeChild", "[]")
    // }else{
    //   localStorage.removeItem("activeChild")
    // } 
  },[])

 
  const handleBack = () => {
    setOptional(null);
    if(handleStepIconClick){
      handleStepIconClick(1);
    }
  };
  function checkChild(tempFeatureList:otherConfigOptionsAttributesFeature[],featureList:otherConfigOptionsAttributesFeature[]){
    const tempFeatureId=tempFeatureList.map((feat)=>{
      return feat.id;
    })??[]
    const featureListId=featureList.map((feat)=>{
      return feat.id;
    })??[]
    if(tempFeatureId.length!==featureListId.length) return false
    for(let i=0;i<tempFeatureId.length;i++){
      if(tempFeatureId[i]!==featureListId[i]) return false;
  }
    return true
}
  function setActiveChild(uiConfigOptionsProp:otherConfigOptionsAttributes[]){
      const feature=uiConfigOptionsProp.find((feature)=>feature.hasASelectedChild);
     return feature?feature.id:feature
  }
   const { optional, setOptional,uiConfigOptionsProp,setUiConfigOptionsProp,changeBottomBar } =
  context!;

 const service = useMemo(() => {
  if (!subFeature?.serviceId) return null;
  return ServiceFactory.getService(subFeature.serviceId);
}, [subFeature?.serviceId,changeBottomBar]);


  function renderActiveChild(params : string | undefined,tempFeatureList:otherConfigOptionsAttributesFeature[]){
    if(!checkChild(tempFeatureList,featureList)) return
    
    if(params === undefined){
      params = "";
    }
    const activeId = params!.toLowerCase().replace(/\s+/g, "");
 
    localStorage.setItem("activeChild", activeId)
    if (!subFeature?.serviceId) {
      return null;
    }

      // case "login":
      //   return <LoginConfiguration/>;
      
        return(
          <div style={{display:"flex",flexDirection:"column", width:"100%"}} >
          <FeatureSelectionComponent  featureList={featureList} setSubFeature={setSubFeature} subFeature={subFeature} setPreviewTrigger={setPreviewTrigger} />
        { 
        featureList.map((item)=>{
          return(
          subFeature?.id===item.id&&service&&<GenericComponentConfig service={service} key={item.id} subFeature={subFeature} preview={previewTrigger[subFeature?.id??""]??0}  
           areDataFieldsValid={dataFieldValidity[item.id] ?? true}
    setAreDataFieldsValid={(isValid: boolean) =>
    setDataFieldValidity((prev) => ({
      ...prev,
      [item.id]: isValid,
    }))
  } />
        )})}
          </div>
        ) 
    
  }
 
 
  const activeChild = optional??setActiveChild(uiConfigOptionsProp)??undefined
  const tempFeatureList = uiConfigOptionsProp.find((option)=>option?.id===activeChild)?.subfeatures?.filter((sub)=>sub.isSelected) ?? uiConfigOptionsProp[0]?.subfeatures?.filter((sub)=>sub.isSelected)??[]

  useEffect(()=>{
    setFeatureList(tempFeatureList)
    setSubFeature(tempFeatureList[0])
    let rec:Record<string,number>={"":0}
    for(let feat of tempFeatureList) 
      rec[feat.id]=0
    setPreviewTrigger(rec)
  },[activeChild,changeBottomBar])

  return (activeChild ? 
    (<>
      <div className={`catalogueContainer`} style={{display: "flex", flexDirection:"row" , gap:"1%" , height:"100%"}}>
        <div style={{width:service?.pwaRequired ? "70%" : "100%"}}>
          <div className="topOptionAndBack">
          {!disableBack && (
            <>
              <IconButton
                color="primary"
                size="small"
                sx={{ fontSize: "1rem", border: "2px solid #1C7EA0" }}
                onClick={handleBack}
              >
                <ArrowBackOutlinedIcon fontSize="small" />
              </IconButton>
            </>
          )}

          <div className="optionalFeatures">
            <ConfigBottomBar
              className="catalougeScroll"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "16px",
                backgroundColor: "white",
                width: "100%",
              }}
              displayMandatory={true}

            />
          </div>
        </div>

        <div className={`configPhoneContainer ${disableBack ? 'shrinked' : ""} ${newPortal ? 'enlarge':""}`}>
          {renderActiveChild(activeChild,tempFeatureList)}
        </div>
      
        {newPortal&&service&&service.pwaRequired&&  
        <Box marginTop={2} sx={{ position: "absolute", bottom: 10, right: 25 }} style={{zIndex:100}}>
          <Button
            endIcon={
              <ArrowRightAltTwoToneIcon
                sx={{ fontSize: { xl: "50px" }, color: "white" }}
              />
            }
            variant="contained"
            onClick={() => {
              if(setCompleted && currentStep !== undefined){
                setCompleted((prev) => ({
                  ...prev,
                  [currentStep]: true,
                }));
              }
              if(handleStepIconClick){
                handleStepIconClick(3);
              }
              return;
            }} className="confirm-button"
            sx={{
              alignSelf: "flex-end",
              marginY: "1.2rem",
              fontSize: "16px",
            }}
          >
            NEXT STEP
          </Button>
        </Box>}
        </div>
      {service&&service.pwaRequired&&
        <div style={{width: "30%",display:"flex",flexDirection:"column",alignItems:"center"}}>
          <div style={{height: "90.5%",marginBottom:"20px"}} id="phone-wrapper">
              <PhoneFrameComponent allowTriggerChanges />
            </div>
        
                      <Button
                      disabled={!(dataFieldValidity[subFeature?.id??""]??true )}
                       onClick={() =>{setPreviewTrigger((prev)=>({...prev,[subFeature?.id??""]:prev[subFeature?.id??""]+1}))
                       }
                       }  
                      sx={{
                      color:"#000000",
                       borderRadius:"8px",
                        fontSize: "12.5px",
                        padding:"8px 14px",
                        backgroundColor: "#ffffff",
                        textTransform:"none",
                        fontWeight:"500",
                        border:"0.5px solid grey"
                      }}
                    >
                      Preview
                    </Button>
            </div>
}
            <div>

            </div>
        </div>
    
    </>) : 
    (
      <Loader/>
    )
  );
};

export default React.memo(OptionalFeatureLayout);
